export default __webpack_public_path__ + "static/media/autoAcceptAlert.72d5668f.wav";